module.exports = __webpack_public_path__ + "img/V lat dcha.79d5be9e.png";